
















import Vue from "vue";
import Component from "vue-class-component";

import * as clearStorageDialogHelper from "../../helpers/clearStorageDialogHelper";

@Component
export default class ClearLocalStorage extends Vue {
  clearLocalStorage() {
    clearStorageDialogHelper.clearLocalStorageDialog(this);
  }
}
